import { CtaButton } from '@workspace/ui/components/dsm/cta-button'
import { useCopyToClipboard } from '../../../../hooks/use-copy-to-clipboard'
import { trackEvent } from '../../../../lib/gtag'
import { SERVER_URL } from './assistant-guide'
import { StepText } from './step-text'

type CopyTarget = 'claude_code' | 'codex_add'

/** A command to paste, with a button that copies exactly what is shown. */
function Command({ children, target }: { children: string; target: CopyTarget }) {
  const { copied, copy } = useCopyToClipboard()
  return (
    <div className="relative">
      <pre className="overflow-x-auto rounded-lg border border-border bg-input/50 p-3 pr-24 text-sm text-foreground">
        {children}
      </pre>
      <CtaButton
        size="sm"
        className="absolute right-2 top-2"
        onClick={() => {
          copy(children)
          trackEvent('assistant_setup_copied', { target })
        }}
      >
        {copied ? 'Copied' : 'Copy'}
      </CtaButton>
    </div>
  )
}

export function OtherAssistantsCard() {
  return (
    <div className="space-y-5 rounded-xl border border-border p-5">
      <p className="text-sm font-medium text-foreground">
        Other assistants can use the server address too, if they let you add a custom connector or
        MCP server with a sign-in.
      </p>
      <div className="space-y-2">
        <h3 className="text-sm font-semibold text-foreground">Claude Code</h3>
        <Command target="claude_code">{`claude mcp add --transport http seedforge ${SERVER_URL}`}</Command>
        <p className="text-sm text-muted-foreground">
          Then type /mcp, choose seedforge and sign in.
        </p>
      </div>
      <div className="space-y-2">
        <h3 className="text-sm font-semibold text-foreground">Codex</h3>
        <Command target="codex_add">{`codex mcp add seedforge --url ${SERVER_URL}`}</Command>
        <p className="text-sm text-muted-foreground">
          Then run codex mcp login seedforge and sign in.
        </p>
      </div>
      <div className="space-y-1">
        <h3 className="text-sm font-semibold text-foreground">Cursor</h3>
        <p className="text-sm text-muted-foreground">
          In Cursor’s settings, add a new MCP server and paste the server address.
        </p>
      </div>
      <div className="space-y-1">
        <h3 className="text-sm font-semibold text-foreground">VS Code</h3>
        <p className="text-sm text-muted-foreground">
          <StepText text="Run {MCP: Add Server} from the command palette, choose HTTP and paste the server address." />
        </p>
      </div>
    </div>
  )
}
